import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useModal } from './useModal';
import { isFunction } from 'lodash';
import modals, { useModals } from '../redux/reducer/modalsData';

export default function useModalsData({ availableTypes = [], openFilterFn, modalsProps = {} } = {}) {
  const { addModal, modals: modalsArray } = useModal();
  const { modalsData } = useModals();
  const dispatch = useDispatch();

  useEffect(() => {
    if (modalsArray.length) return;

    const isDeleted = modalsData.filter((el) => {
      const id = el?.id;
      if (id === undefined) return;
      dispatch(modals.actions.removeShowedModal(id));
      return true;
    }).length;

    if (isDeleted) return;

    if (modalsData.length) {
      const currentModal = modalsData[0];

      if (availableTypes.length && !availableTypes.includes(currentModal.type)) return; // фильтрация по типу
      if (isFunction(openFilterFn) && !openFilterFn(currentModal)) return; // проверка в функции

      const { type, props } = currentModal;

      const { id } = addModal({ type, props: { ...modalsProps, ...props } });

      dispatch(modals.actions.addIdToShowedModal(id));
    }
  }, [modalsArray.length, modalsData.length]);
}
